// extracted by mini-css-extract-plugin
export default {"title":"title___jbB5I"};